import React from "react";
import TextField from "@mui/material/TextField";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import useConfig from "hooks/useConfig";
import { DateTime } from "luxon";
import { useTranslation } from "react-i18next";
import Card from "components/common/card/Card.component";
import { useMediaQuery } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const DatePickerComponent = ({
  onClickDate = () => { },
  value,
  minDate
}) => {
  const { locale } = useConfig();
  const { t } = useTranslation();
  const matchDown = useMediaQuery("(max-width:400px)");

  return (
    <Card padding={0} sx={{ minHeight: matchDown ? "auto" : 464 }}>
      {matchDown ?
        <LocalizationProvider
          locale={locale ? locale : "it"}
          dateAdapter={AdapterLuxon}
        >
          <DatePicker
            label={t("Select date")}
            maxDate={DateTime.now().minus({ days: 1 })}
            minDate={minDate}
            value={value}
            onChange={(newDate) => onClickDate(newDate)}
            renderInput={(params) => (
              <TextField
                {...params}
                helperText={null}
                margin="normal"
                sx={{ marginLeft: 2, marginRight: 2, width: "90%" }}
              />
            )}
          />
        </LocalizationProvider>
        : <LocalizationProvider
          locale={locale ? locale : "it"}
          dateAdapter={AdapterLuxon}
        >
          <StaticDatePicker
            toolbarTitle={t("Select date")}
            orientation="portrait"
            openTo="day"
            value={value}
            disableFuture={true}
            maxDate={DateTime.now().minus({ days: 1 })}
            minDate={minDate}
            onChange={(newValue) => {
              onClickDate(newValue);
            }}
            showDaysOutsideCurrentMonth={true}
            toolbarFormat="d MMM yyyy"
            renderInput={(params) => <TextField {...params} fullWidth />}
            style={{
              "& .MuiCalendarPicker-root": {
                width: 500,
              },
            }}
            componentsProps={{
              actionBar: {
                actions: ["today"],
              },
            }}
          />
        </LocalizationProvider>}
    </Card>
  );
};
export default DatePickerComponent;
